import React, { Fragment } from 'react';
import Header from '../components/Header';

import CoverImage from '../components/CoverImage';
import specialOffers from '../assets/images/specialOffers.jpg';
import { Container, Image } from '../components/Section';
import styled from 'styled-components';
import isArray from 'lodash-es/isArray';
import { Slideshow } from '../components/slideshow/Slideshow';
import { H4, Italic } from '../components/typography';
import {
  TrianglesBottomLeft,
  TrianglesBottomRight,
  TrianglesTopLeft,
  TrianglesTopRight,
} from '../components/Triangles';
import responsive, { breakpoint } from '../utils/responsive';
import theme from '../theme';
import { Helmet } from 'react-helmet';
import withHelmet from '../utils/withHelmet';

const OfferContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${props => (props.reversed ? 'row' : 'row-reverse')};
  background: white;
  > * {
    width: 50%;
  }
  flex: 1 0 auto;

  * > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  ${responsive.sm.andSmaller`
    flex-wrap: wrap;   
    flex: 1 0 auto;
    flex-flow: column-reverse;
    
    > * {
      width: 100%;
    }
  
  `}
`;

const OfferTitle = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  ${responsive.sm.andSmaller`
    // background: ${theme.colors.primary.alpha(0.7).toHex()};
    z-index: 10;
    // background: #ae609fb3;
    position: relative;
    top: 20%;
  `};
`;

const Decoration = ({ reversed }) =>
  reversed ? (
    <Fragment>
      <TrianglesBottomRight style={{ width: '40%', opacity: 0.3 }} />
      <TrianglesTopLeft style={{ width: '40%', opacity: 0.3 }} />
    </Fragment>
  ) : (
    <Fragment>
      <TrianglesTopRight style={{ width: '40%', opacity: 0.3 }} />
      <TrianglesBottomLeft style={{ width: '40%', opacity: 0.3 }} />
    </Fragment>
  );

const Offer = ({ title, image, reversed }) => (
  <OfferContainer reversed={reversed}>
    {isArray(image) ? (
      <Slideshow
        images={image}
        style={{ height: '50vh', objectFit: 'contain' }}
      />
    ) : (
      <Image src={image} style={{ maxHeight: '100vh', objectFit: 'fill' }} />
    )}
    <OfferTitle>
      <Italic>
        <H4>{title}</H4>
      </Italic>
      <Decoration
        reversed={window.innerWidth < breakpoint.md ? true : reversed}
      />
    </OfferTitle>
  </OfferContainer>
);

const OffersPage = ({ content }) => (
  <Fragment>
    <Helmet>
      <title>{`LaVilla ${content.general.specialOffers}`}</title>
    </Helmet>
    <div style={{ position: 'relative' }}>
      <Container>
        <CoverImage
          src={specialOffers}
          style={{
            height: '50vh',
            zIndex: 3,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: window.innerWidth > breakpoint.md ? '2em' : '8em',
            left: 0,
            width: '100%',
            zIndex: 4,
          }}
        >
          <Header
            title={'La Vill'}
            subtitle={content.general.specialOffers}
            style={{ marginTop: 0 }}
          />
        </div>
      </Container>
      {content.offers.map((offer, i) => (
        <Offer
          key={offer.id}
          title={offer.title}
          image={offer.image}
          reversed={i % 2 === 0}
        />
      ))}
    </div>
  </Fragment>
);

export default withHelmet('offers')(OffersPage);
